"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var styles = __importStar(require("./ResizerComponent.css"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var inversify_react_1 = require("inversify-react");
var ProjectDimensionStore_1 = require("Project/Stores/ProjectDimensionStore/ProjectDimensionStore");
var WIDE_SIZE_RATIOS = {
    SMALL_SCREEN: 1,
    MEDIUM_SCREEN: 1.15,
    WIDE_SCREEN: 1.33,
};
var WIDE_SIZE_BREAKPOINTS = {
    MEDIUM_SCREEN: 1140,
    WIDE_SCREEN: 1440,
};
var SNAP_GAP = 16;
var CONTENT_WIDTH_SNAP_BUFFER = 40;
var MIN_SIZE_PX = 50;
var BLOCK_ELEMENT_CLASS = "project-block__block-element";
var ResizerComponent = (function (_super) {
    __extends(ResizerComponent, _super);
    function ResizerComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isResizing = false;
        _this.resizerRef = react_1.default.createRef();
        _this.snapPoint = undefined;
        _this.snapAreasVisible = false;
        _this.editorContentWidth = 0;
        _this.supportsWideResizing = false;
        _this.startResizing = function (event, direction) {
            event.preventDefault();
            _this.direction = direction;
            _this.originalAlignment = _this.props.alignment === "left" ? "left" : "center";
            if (!_this.resizerRef.current || !_this.resizerRef.current.parentElement) {
                return;
            }
            var width = _this.widgetWidthToPixels(_this.props.width);
            var height = _this.percentToPixels({
                height: _this.props.height,
                width: typeof _this.props.width === "number" ? _this.props.width : (width / _this.editorContentWidth) * 100,
            }).height;
            _this.width = width;
            _this.height = height;
            _this.startSizePx = {
                x: width !== null && width !== void 0 ? width : 0,
                y: height !== null && height !== void 0 ? height : 0,
            };
            _this.startClickPoint = { x: event.clientX, y: event.clientY };
            _this.isResizing = true;
            _this.snapPoint = typeof _this.props.width === "string" ? _this.props.width : "custom";
            if (["ne", "sw"].includes(direction)) {
                document.body.style.cursor = "nesw-resize";
            }
            else if (["nw", "se"].includes(direction)) {
                document.body.style.cursor = "nwse-resize";
            }
            document.addEventListener("mouseup", _this.stopResizing);
            document.addEventListener("mousemove", _this.resize);
        };
        _this.resize = function (event) {
            var movedPx = { x: 0, y: 0 };
            switch (_this.direction) {
                case "ne":
                    movedPx.x = event.clientX - _this.startClickPoint.x;
                    movedPx.y = _this.startClickPoint.y - event.clientY;
                    break;
                case "se":
                    movedPx.x = event.clientX - _this.startClickPoint.x;
                    movedPx.y = event.clientY - _this.startClickPoint.y;
                    break;
                case "nw":
                    movedPx.x = _this.startClickPoint.x - event.clientX;
                    movedPx.y = _this.startClickPoint.y - event.clientY;
                    break;
                case "sw":
                    movedPx.x = _this.startClickPoint.x - event.clientX;
                    movedPx.y = event.clientY - _this.startClickPoint.y;
                    break;
            }
            var finalSizePx = {
                x: _this.startSizePx.x + movedPx.x * 2,
                y: _this.startSizePx.y + movedPx.y,
            };
            if (!_this.supportsWideResizing) {
                _this.width = (0, lodash_1.clamp)(finalSizePx.x, _this.props.minWidthPx, _this.editorContentWidth);
            }
            else {
                _this.width = Math.max(finalSizePx.x, _this.props.minWidthPx);
            }
            _this.height = Math.max(finalSizePx.y, _this.props.minHeightPx);
            _this.recalculateSnapPoint();
            if (_this.width >= _this.maxCustomWidth) {
                _this.snapAreasVisible = true;
            }
            else {
                _this.snapAreasVisible = false;
            }
            var shouldForceCenterAlignment = _this.width > _this.editorContentWidth && _this.props.alignment === "left";
            var shouldResetLeftAlignment = _this.width <= _this.editorContentWidth && _this.props.alignment === "center" && _this.originalAlignment === "left";
            if (shouldForceCenterAlignment) {
                _this.props.handleAlignmentChange("center");
            }
            else if (shouldResetLeftAlignment) {
                _this.props.handleAlignmentChange("left");
            }
        };
        _this.stopResizing = function () {
            var _a;
            _this.startSizePx = null;
            _this.direction = null;
            _this.isResizing = false;
            var snappedWidth = getSnappedWidth({
                snap: _this.snapPoint,
                width: _this.width,
            });
            var width;
            var height;
            if (typeof snappedWidth === "number") {
                (_a = _this.pixelToPercent({ width: snappedWidth, height: _this.height }), width = _a.width, height = _a.height);
            }
            else {
                (height = _this.pixelToPercent({ width: _this.width, height: _this.height }).height);
                width = snappedWidth;
            }
            _this.props.handleResize(width, height);
            document.body.style.cursor = "";
            var shouldResetLeftAlignment = _this.props.alignment === "center" &&
                _this.originalAlignment === "left" &&
                snappedWidth !== "wide" &&
                snappedWidth !== "full";
            if (shouldResetLeftAlignment) {
                _this.props.handleAlignmentChange("left");
            }
            _this.originalAlignment = null;
            _this.snapAreasVisible = false;
            _this.snapPoint = undefined;
            document.removeEventListener("mouseup", _this.stopResizing);
            document.removeEventListener("mousemove", _this.resize);
        };
        return _this;
    }
    Object.defineProperty(ResizerComponent.prototype, "pageContentWidth", {
        get: function () {
            return this.projectDimensionStore.pageContentWidth;
        },
        enumerable: false,
        configurable: true
    });
    ResizerComponent.prototype.componentDidMount = function () {
        var _this = this;
        var layoutElement = this.resizerRef.current.closest('[data-layout-node="true"]');
        if (layoutElement.classList.contains("new-editor")) {
            this.supportsWideResizing = true;
        }
        if (typeof ResizeObserver !== "undefined") {
            var resizeObserver_1 = new ResizeObserver(function (entries) {
                if (entries.length > 0) {
                    var _a = __read(entries, 1), layoutElementEntry_1 = _a[0];
                    (0, mobx_1.runInAction)(function () {
                        _this.editorContentWidth = layoutElementEntry_1.contentBoxSize[0].inlineSize;
                    });
                }
            });
            resizeObserver_1.observe(layoutElement);
            this.unobserveLayoutElement = function () { return resizeObserver_1.unobserve(layoutElement); };
        }
    };
    ResizerComponent.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.unobserveLayoutElement) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    ResizerComponent.prototype.percentToPixels = function (percent) {
        var widthInPixels = (percent.width / 100) * this.editorContentWidth;
        var height = 0;
        if (this.props.aspectRatio) {
            height = widthInPixels * this.props.aspectRatio;
        }
        else {
            height = (percent.height / 100) * widthInPixels;
        }
        return {
            width: widthInPixels,
            height: height,
        };
    };
    ResizerComponent.prototype.pixelToPercent = function (_a) {
        var width = _a.width, height = _a.height;
        return {
            width: (width / this.editorContentWidth) * 100,
            height: (height / width) * 100,
        };
    };
    ResizerComponent.prototype.widgetWidthToPixels = function (width) {
        if (typeof width === "number") {
            return this.percentToPixels({ width: width, height: 0 }).width;
        }
        if (width === "content") {
            return this.editorContentWidth;
        }
        if (width === "wide") {
            return this.getWideWidth();
        }
        return this.pageContentWidth;
    };
    ResizerComponent.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f;
        var _this = this;
        var width = this.widgetWidthToPixels(this.props.width);
        var height = this.percentToPixels({
            height: this.props.height,
            width: (width / this.editorContentWidth) * 100,
        }).height;
        if (this.isResizing) {
            width = this.width;
            height = this.height;
        }
        var resizerStyle = { width: "".concat(width, "px") };
        if (this.props.resizableHeight) {
            resizerStyle.paddingBottom = "".concat((height / width) * 100, "%");
        }
        if (this.props.preserveAspectRatio) {
            resizerStyle.aspectRatio = "".concat(this.props.aspectRatio);
        }
        var contentWidth = this.editorContentWidth;
        var wideWidth = this.getWideWidth();
        var snapPoint = this.snapPoint;
        return (react_1.default.createElement("div", { className: styles.resizeableContainer({
                alignment: this.props.alignment === "left" ? "left" : "center",
            }) },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.resizeableSnapArea({
                    highlighted: snapPoint === "full",
                    visible: this.showSnapAreas,
                }), styles.snapAreaFull), style: __assign({}, (0, dynamic_1.assignInlineVars)((_a = {},
                    _a[styles.snapAreaWidth] = "".concat(this.pageContentWidth / 2 - wideWidth / 2 - SNAP_GAP, "px"),
                    _a[styles.snapAreaXOffset] = "-".concat(this.pageContentWidth / 2 - contentWidth / 2, "px"),
                    _a))) }),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.resizeableSnapArea({
                    highlighted: snapPoint === "wide",
                    visible: this.showSnapAreas,
                }), styles.snapAreaWide), style: (0, dynamic_1.assignInlineVars)((_b = {},
                    _b[styles.snapAreaWidth] = "".concat((wideWidth - contentWidth) / 2 - SNAP_GAP, "px"),
                    _b[styles.snapAreaXOffset] = "-".concat((wideWidth - contentWidth) / 2, "px"),
                    _b)) }),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.resizeableSnapArea({
                    highlighted: snapPoint === "content",
                    visible: this.showSnapAreas,
                }), styles.resizeableSnapAreaContentStart), style: (0, dynamic_1.assignInlineVars)((_c = {}, _c[styles.snapAreaWidth] = "".concat(CONTENT_WIDTH_SNAP_BUFFER, "px"), _c)) }),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.resizeableSnapArea({
                    highlighted: snapPoint === "content",
                    visible: this.showSnapAreas,
                }), styles.resizeableSnapAreaContentEnd), style: (0, dynamic_1.assignInlineVars)((_d = {}, _d[styles.snapAreaWidth] = "".concat(CONTENT_WIDTH_SNAP_BUFFER, "px"), _d)) }),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.resizeableSnapArea({
                    highlighted: snapPoint === "wide",
                    visible: this.showSnapAreas,
                }), styles.snapAreaWide), style: (0, dynamic_1.assignInlineVars)((_e = {},
                    _e[styles.snapAreaXOffset] = "".concat(contentWidth + SNAP_GAP, "px"),
                    _e[styles.snapAreaWidth] = "".concat((wideWidth - contentWidth) / 2 - SNAP_GAP, "px"),
                    _e)) }),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.resizeableSnapArea({
                    highlighted: snapPoint === "full",
                    visible: this.showSnapAreas,
                }), styles.snapAreaFull), style: (0, dynamic_1.assignInlineVars)((_f = {},
                    _f[styles.snapAreaXOffset] = "".concat(contentWidth + (wideWidth - contentWidth) / 2 + SNAP_GAP, "px"),
                    _f[styles.snapAreaWidth] = "".concat(this.pageContentWidth / 2 - wideWidth / 2 - SNAP_GAP, "px"),
                    _f)) }),
            react_1.default.createElement("div", { className: (0, classnames_1.default)("resize-widget__resizer-container", BLOCK_ELEMENT_CLASS, {
                    "resize-widget__resizer-container--left-aligned": this.props.alignment === "left",
                }), style: resizerStyle, ref: this.resizerRef, contentEditable: false },
                react_1.default.createElement("div", { className: styles.resizeWidgetSubject({
                        disablePointerEvents: this.isResizing,
                        resizableHeight: this.props.resizableHeight,
                    }) }, this.props.children),
                react_1.default.createElement("div", { contentEditable: false },
                    react_1.default.createElement("div", { onMouseDown: function (event) { return _this.startResizing(event, "nw"); }, className: styles.resizeHandle({
                            selected: this.props.isSelected,
                            position: "topLeft",
                            inset: this.props.width === "full",
                        }) }),
                    react_1.default.createElement("div", { onMouseDown: function (event) { return _this.startResizing(event, "ne"); }, className: styles.resizeHandle({
                            selected: this.props.isSelected,
                            position: "topRight",
                            inset: this.props.width === "full",
                        }) }),
                    react_1.default.createElement("div", { onMouseDown: function (event) { return _this.startResizing(event, "sw"); }, className: styles.resizeHandle({
                            selected: this.props.isSelected,
                            position: "bottomLeft",
                            inset: this.props.width === "full",
                        }) }),
                    react_1.default.createElement("div", { onMouseDown: function (event) { return _this.startResizing(event, "se"); }, className: styles.resizeHandle({
                            selected: this.props.isSelected,
                            position: "bottomRight",
                            inset: this.props.width === "full",
                        }) })))));
    };
    ResizerComponent.prototype.recalculateSnapPoint = function () {
        if (!this.supportsWideResizing) {
            this.snapPoint = "custom";
            return;
        }
        var wideWidth = this.getWideWidth();
        if (this.width < this.maxCustomWidth) {
            this.snapPoint = "custom";
        }
        else if (this.width <= this.editorContentWidth + SNAP_GAP * 2) {
            this.snapPoint = "content";
        }
        else if (this.width <= wideWidth + SNAP_GAP * 2) {
            this.snapPoint = "wide";
        }
        else {
            this.snapPoint = "full";
        }
    };
    ResizerComponent.prototype.getWideWidthRatio = function () {
        if (this.pageContentWidth <= WIDE_SIZE_BREAKPOINTS.MEDIUM_SCREEN) {
            return WIDE_SIZE_RATIOS.SMALL_SCREEN;
        }
        if (this.pageContentWidth <= WIDE_SIZE_BREAKPOINTS.WIDE_SCREEN) {
            return WIDE_SIZE_RATIOS.MEDIUM_SCREEN;
        }
        return WIDE_SIZE_RATIOS.WIDE_SCREEN;
    };
    ResizerComponent.prototype.getWideWidth = function () {
        return this.editorContentWidth * this.getWideWidthRatio();
    };
    Object.defineProperty(ResizerComponent.prototype, "showSnapAreas", {
        get: function () {
            return this.snapAreasVisible && this.supportsWideResizing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResizerComponent.prototype, "maxCustomWidth", {
        get: function () {
            return this.editorContentWidth - CONTENT_WIDTH_SNAP_BUFFER * 2;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    ResizerComponent.defaultProps = {
        minWidthPx: MIN_SIZE_PX,
        minHeightPx: MIN_SIZE_PX,
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ResizerComponent.prototype, "isResizing", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], ResizerComponent.prototype, "width", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], ResizerComponent.prototype, "height", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], ResizerComponent.prototype, "snapPoint", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ResizerComponent.prototype, "snapAreasVisible", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ResizerComponent.prototype, "editorContentWidth", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("projectDimensionStore"),
        __metadata("design:type", typeof (_a = typeof ProjectDimensionStore_1.ProjectDimensionStore !== "undefined" && ProjectDimensionStore_1.ProjectDimensionStore) === "function" ? _a : Object)
    ], ResizerComponent.prototype, "projectDimensionStore", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ResizerComponent.prototype, "supportsWideResizing", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ResizerComponent.prototype, "startResizing", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ResizerComponent.prototype, "resize", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ResizerComponent.prototype, "stopResizing", void 0);
    ResizerComponent = __decorate([
        mobx_react_1.observer
    ], ResizerComponent);
    return ResizerComponent;
}(react_1.default.Component));
exports.default = ResizerComponent;
var getSnappedWidth = function (_a) {
    var snap = _a.snap, width = _a.width;
    switch (snap) {
        case "custom": {
            return width;
        }
        default: {
            return snap;
        }
    }
};
